<div class="container">
  <section class="thumbnail-container">
    <section class="actions">
      <p-splitButton
        label="Open"
        [model]="menuItems"
        appendTo="body"
        size="small"
        icon="pi fi fi-rr-graphic-style"
        (onClick)="open.emit()"
        severity="primary"
      />
    </section>
    <div class="thumbnail-image">
      <div
        [style.background-color]="loaded && 'black'"
        class="overflow-container"
      >
        <p-skeleton
          [style.display]="!loaded ? 'inline' : 'none'"
          width="100%"
          height="100%"
        />
        <img
          crossorigin="anonymous"
          [style.display]="loaded ? 'block' : 'none'"
          [src]="renderData.thumbnailImage"
          (load)="onLoaded()"
        />
      </div>
    </div>
  </section>
  <section class="title">
    <div class="large-text">
      <h4 tooltipPosition="top" [pTooltip]="renderData.renderName">{{renderData.renderName}}</h4>
      <h5>{{renderData.imageSize[0]}}px · {{renderData.imageSize[1]}}px</h5>
    </div>
    <div class="metadata">
      <div class="left">
        <p>Updated: {{renderData.lastUpdated | date: 'short' }}</p>
        <p>Created: {{renderData.created | date: 'short' }}</p>
      </div>
      <div class="right">
        <p-button
          icon="pi pi-comments"
          [text]="true"
          [outlined]="true"
          [badge]="renderData.comments?.length?.toString()"
          size="small"
          severity="success"
          pTooltip="Comments"
          tooltipPosition="bottom"
          (onClick)="comments.emit()"
        />
      </div>
    </div>
  </section>
  <section class="expandable-info">
  </section>
</div>
